/* eslint-disable max-len */
import React from 'react';

const ControlCenterLogos: React.FC<{
  color: string;
  product: string;
}> = ({color, product}) =>
  product === 'ESG' ? (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="49"
      height="49"
      viewBox="0 0 49 49"
      fill="none"
    >
      <g clipPath="url(#clip0_12308_6043)">
        <path d="M48.5898 0.5H0.589844V48.5H48.5898V0.5Z" fill="none" />
        <path
          d="M13.8279 20.1182H24.2539C24.7995 22.0321 25.4711 24.3826 26.319 27.3543C27.427 31.2325 28.9381 36.5043 31.0955 44.0678H6.98633C9.14373 36.5043 10.6547 31.2409 11.7628 27.3543C12.6107 24.391 13.2822 22.0321 13.8279 20.1266V20.1182Z"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.5688 24.5254H25.4964"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M28.2832 32.6423H32.6568V24.0547H36.6861L42.0838 32.6423L42.193 44.0589H31.5907"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M34.0923 37.6709H37.9202"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M28.619 4.94043C26.0251 5.20066 21.6684 6.11567 18.8058 7.99604C15.9853 9.85124 14.7345 12.8061 17.4627 15.5092C18.4532 16.4913 19.7292 17.0622 20.9212 17.1629C24.2287 17.4567 25.3536 13.7127 26.1678 11.144C26.8982 8.8355 27.5194 6.43466 28.619 4.94043Z"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M17.4629 15.5097C17.4629 15.5097 20.124 11.3292 24.3716 8.13086"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M18.6211 13.8982L22.6421 13.3105"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M20.6191 11.5389L20.5352 8.18945"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.2173 30.0322H17.5384"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_12308_6043">
          <rect
            width="48"
            height="48"
            fill="none"
            transform="translate(0.589844 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  ) : product === 'CA' ? (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="48"
      height="49"
      viewBox="0 0 48 49"
      fill="none"
    >
      <g clipPath="url(#clip0_12308_6026)">
        <path d="M48 0.5H0V48.5H48V0.5Z" fill="none" />
        <path
          d="M33.0661 35.7316L23.3872 44.7222C21.9937 46.0149 19.8028 45.931 18.5184 44.5459L10.1239 35.505C8.40298 33.6498 8.51211 30.7285 10.3589 29.0076L21.7251 18.4473L33.2508 30.8544C34.5436 32.2479 34.4596 34.4389 33.0745 35.7232L33.0661 35.7316Z"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M27.3579 24.5172L29.2803 22.7292C29.5405 22.4858 29.9602 22.5025 30.2037 22.7628L34.9886 27.917C35.232 28.1773 35.2152 28.597 34.955 28.8404L33.0326 30.6285"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M25.6623 37.461C23.0684 39.8702 19.0054 39.7275 16.5878 37.1252C14.1786 34.5313 14.3213 30.4683 16.9236 28.0507C19.5175 25.6414 23.5804 25.7842 25.9981 28.3865C28.4073 30.9804 28.2646 35.0433 25.6623 37.461Z"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M21.876 18.3046L35.5675 5.58691L39.1016 9.39804L25.4101 22.1158"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M32.8395 8.12205L31.253 6.41796C30.6402 5.75479 30.6737 4.71386 31.3369 4.10106L31.6559 3.79886C32.3191 3.18606 33.36 3.21964 33.9728 3.8828L35.5594 5.5869"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M23.6728 30.5439C24.8984 31.8619 24.8228 33.9186 23.5049 35.1442"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M37.3975 10.901L36.1719 9.58301"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M35.3999 12.7564L34.1743 11.4385"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M33.4439 14.6529L32.2183 13.335"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M31.4458 16.5084L30.2202 15.1904"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M29.4063 18.3302L28.1807 17.0039"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M27.4082 20.1847L26.1826 18.8584"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_12308_6026">
          <rect
            width="48"
            height="48"
            fill="none"
            transform="translate(0 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  ) : (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="48"
      height="49"
      viewBox="0 0 48 49"
      fill="none"
    >
      <g clipPath="url(#clip0_12308_6057)">
        <path d="M48 0.5H0V48.5H48V0.5Z" fill="none" />
        <path
          d="M29.6326 33.2807L29.6914 41.5493C29.6914 42.2124 29.1541 42.7581 28.491 42.7665L20.4322 42.8252C19.769 42.8252 19.2234 42.288 19.215 41.6248L19.1562 33.3814C18.7953 31.9123 16.9065 29.7801 16.9065 29.7801C15.1688 27.9585 14.0943 25.4905 14.0691 22.7791C14.0272 17.1212 18.5854 12.5042 24.2433 12.4622C28.9191 12.4286 32.8897 15.5346 34.1489 19.8074"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M19.1982 38.5941L29.6662 38.5186"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M26.7868 42.7832C26.7952 44.0676 25.7627 45.1085 24.4783 45.1253C23.1939 45.1337 22.153 44.1011 22.1362 42.8168L26.7784 42.7832H26.7868Z"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M24.4199 31.8369L24.4451 35.7488"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M23.085 30.5605L24.4281 31.8869"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M25.7376 30.5439L24.4028 31.8955"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M24.168 4.29395L24.2015 8.23099"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M34.149 3.88281L31.1689 10.0192"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M39.3282 10.498L35.5171 13.8307"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.0439 4.01758L17.108 10.1204"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.95703 10.708L12.8101 13.9819"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M4.14697 18.4053L10.5352 19.6141"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.58984 27.7491L11.0725 26.6494"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M37.3727 19.6143H34.1659L33.763 21.2008C33.3601 21.3267 32.9739 21.4862 32.6046 21.6793L31.2027 20.8483L28.9361 23.1148L29.7672 24.5167C29.5741 24.886 29.4146 25.2722 29.2887 25.6751L27.7021 26.0781V29.2848L29.2887 29.6877C29.4146 30.0906 29.5741 30.4768 29.7672 30.8462L28.9361 32.248L31.2027 34.5146L32.6046 33.6835C32.9739 33.8766 33.3601 34.0361 33.763 34.162L34.1659 35.7486H37.3727L37.7756 34.162C38.1785 34.0361 38.5647 33.8766 38.934 33.6835L40.3359 34.5146L42.6025 32.248L41.7714 30.8462C41.9645 30.4768 42.124 30.0906 42.2499 29.6877L43.8365 29.2848V26.0781L42.2499 25.6751C42.124 25.2722 41.9645 24.886 41.7714 24.5167L42.6025 23.1148L40.3359 20.8483L38.934 21.6793C38.5647 21.4862 38.1785 21.3267 37.7756 21.2008L37.3727 19.6143Z"
          stroke={color}
          strokeWidth="0.98"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M35.786 31.2488C37.7588 31.2488 39.3621 29.6455 39.3621 27.6728C39.3621 25.7 37.7588 24.0967 35.786 24.0967C33.8133 24.0967 32.21 25.6916 32.21 27.6728C32.21 29.6539 33.8049 31.2488 35.786 31.2488Z"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_12308_6057">
          <rect
            width="48"
            height="48"
            fill="none"
            transform="translate(0 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );

export default ControlCenterLogos;
